var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcGenderMaleRegular = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.282 18.967a6.25 6.25 0 1 0 8.839-8.839 6.25 6.25 0 0 0-8.84 8.84m9.9 1.06a7.75 7.75 0 1 1-10.96-10.96 7.75 7.75 0 0 1 10.96 10.96",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.12 10.128a.75.75 0 0 1 0-1.06l4.243-4.243a.75.75 0 0 1 1.06 1.06l-4.242 4.243a.75.75 0 0 1-1.06 0",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.06 10.694a.75.75 0 0 1-.848-.637l-.628-4.392-4.393-.628a.75.75 0 1 1 .212-1.485l4.95.707a.75.75 0 0 1 .637.637l.707 4.95a.75.75 0 0 1-.637.848",
  clipRule: "evenodd"
})));
export default SvgIcGenderMaleRegular;